export default "__VITE_ASSET__MWBCMy9z__"